import classnames from 'classnames';
import React from 'react';

import { TabContentContainerStyled } from './styled';
import { ITabContentProps } from './types';

const TabContent: React.FC<ITabContentProps> = ({ children, active, className }) => (
  <TabContentContainerStyled
    className={classnames(`custom-tabs-content ${className || ''}`, {
      'custom-tabs-content-active ': active,
      'gx-d-none': !active,
    })}>
    {children}
  </TabContentContainerStyled>
);

export default React.memo(TabContent);
